const mode = "production" // production, local
const endpoint_url = mode !== "local" ? (window.location.origin+"/api/handle-request.php") : "http://cpa.local/handle-request.php";

export default endpoint_url;